@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.support

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.support.ExtendedSupportItemDto


object GetSupportItemsEndpoint : EndPoint<GetSupportItemsEndpoint.Request, GetSupportItemsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<ExtendedSupportItemDto>,
        val total: Int
    )
}